import DataTable from 'components/Core/DataTable';
import PurchaseOrder from 'lib/Core/Backend/Controllers/PurchaseOrder';
import React, { useEffect, useMemo, useRef, useState } from 'react';
import ReactNotificationAlert from 'react-notification-alert';
import Notify from "../../lib/Utils/Alert";
import { Alert, Col, Row } from 'reactstrap';
import Utils from 'lib/Utils/Utils';

const calculateSubTotal = (amount, quantity, fees, discount) => {
  return ((amount * quantity) - ((amount * quantity) * (discount / 100))) + (quantity * fees);
}

const OrderBatch = (props) => {
  const {order, token, brands, cardTypes,openDrawer} = props;
const poCtl = useMemo(() => new PurchaseOrder(token), [token]);

  const dollar = useMemo(() => Intl.NumberFormat('en-US', {
    style: "currency",
    currency: "USD",
  }),[]);

  const table = useRef();
  const alert = useRef();
  
  const [total, setTotal] = useState('')
  const [loading,setLoading] = useState(true)
  const [orderBatchData,setOrderBatchData] = useState([])
  
  
  const headers = [
    {title:"Order Name",data:"ordername", searchable: true, sortable: true},
    {title:"Brand Id",data:"brandId", searchable: true, sortable: true},
    {title:"Brand", data:"brand",  searchable: true, sortable: true},
    
    
    {title:"Gift card id",data:"cardTypeId", searchable: true, sortable: true},
    {title:"Gift card denomination",data:"denomination" ,searchable: true, sortable: true,render:(data) =>{
      if(data){
        return data
      }else return ``
    }},
    {title:"Quantity",data:"Qty", searchable: true, sortable: true},
    {title:"Batch Qty",data:"batchQty", searchable: true, sortable: true},
    {title:"Batch Id",data:"batchid" ,searchable: true, sortable: true},
    {title:"Batch Status",data:"status", searchable: true, sortable: true},
    
    
  ]

  const onDraw = () => {
    if (table.current)
		{
			if(table.current.dataTable.rows().data()){
				let total = table.current.dataTable.rows().data()
					.reduce((a, b) =>
					{
						return a + b.subtotal;
					}, 0);

				setTotal(dollar.format(total));
			} else {
				setTotal('$0.00');
			}
		}
  }

 


  const fetchData =() =>{
    setLoading(true)
    poCtl.purchaseOrderBatch(order?.name, data => {
      if(data.error || data.errorMessage){
        Notify(alert, 'danger', data.errorMessage ?? data.error)
        setLoading(false)
      } else {
        // if(table.current){
          let orderDetails = data.map(detail => {
            const currencyFormat = new Intl.NumberFormat('en-US', {
              style: 'currency',
              currency: order?.currency ?? 'USD'
            })
            
            return {
              ...detail,
             brand:detail.denomination,
             ordername:detail.purchaseOrderName,
             brandId:detail.brandId,
             denomination:detail.amount,
             cardTypeId:detail.giftCardTypeId,
             Qty:detail.originalQty,
             batchQty:detail.batchQty,
             batchid:detail.batchId,
             status:detail.batchStatus,
              currency: order.currency,
              
            }
          })
          setLoading(false)
          setOrderBatchData(orderDetails)
          // table.current.dataTable.clear().rows.add(orderDetails).draw()
        // }
      }
    })
  }

  useEffect(() => {
    if (openDrawer) {
      fetchData();
    } else if (table.current) {
      table.current.dataTable.clear().draw();
    }
  }, [openDrawer, poCtl, order, brands, cardTypes]);


  return (
    <>
      <ReactNotificationAlert ref={alert} />
      <Row className='justify-content-between m-4'>
        <Col>
          <div>
            <h4>Batch Details</h4>
            {/* <DataTable
              options={{
                paging: false,
                searching: false,
                responsive: true,
                info: false,
                saveState: true,
                // drawCallback: onDraw,
              }}
              ref={table}
              data={null}
              columns={headers}
            /> */}

<div className='table-responsive'>
          <table class="table purchaser_class table dataTable no-footer order_details_table">
            <thead>
              <tr>
                
                <th>Order Name</th>
                <th>Brand Id</th>
                <th>Brand</th>
                <th>Gift card id</th>
                <th>Gift card denomination</th>
                <th>Quantity</th>
                <th>Batch </th>
                <th>Batch Id</th>
                <th>Batch Status</th>
                

              </tr>
            </thead>
            <tbody>
            {loading ? (
            <tr>
              <td colSpan="10" className="">
              <div className='d-flex justify-content-center align-items-center flex-column vh-50'>
								   <div className="spinner-border text-muted text-center"></div>
								</div>
              </td>
            </tr>
          ) : orderBatchData.length > 0 ? (
            orderBatchData.map((item, index) => {
              return (
                <tr key={index}>
                
                <td>{item?.ordername}</td>
                <td>{item?.brandId}</td>
                <td>{item?.brand}</td> 
                <td>{item?.cardTypeId}</td>
                <td>{item?.denomination}</td>
                <td>{item?.Qty}</td>
                <td>{item?.batchQty}</td>
                <td>{item?.batchid}</td>
                <td>{item?.status}</td>
              
            </tr>
              )
             
            })
          ) : (
            <tr>
              <td colSpan="10" className="text-center">
                No data available
              </td>
            </tr>
          )}
            </tbody>
          </table>
          </div>
          </div>
          
        </Col>
      </Row>
     
    </>
  );
}
 
export default OrderBatch;
